(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vitae-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.documentElement.classList.add('vt-js');
  function boot(){
    var t=document.getElementById('vtNavToggle'), l=document.getElementById('vtNavLinks');
    if(t&&l&&!t.dataset.bound){t.dataset.bound='1';t.addEventListener('click',function(){var o=l.classList.toggle('open');t.setAttribute('aria-expanded',o?'true':'false');});}
    var els=document.querySelectorAll('.vt .reveal');
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1,rootMargin:'0px 0px -7% 0px'});
    els.forEach(function(e){io.observe(e);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitae-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(seg){
    if(seg.dataset.bound)return; seg.dataset.bound='1';
    var stage=seg.closest('.hero-stage');
    var frame=stage.querySelector('.hero-frame');
    var cap=stage.querySelector('.hero-caption');
    var thumb=seg.querySelector('.seg-thumb');
    var btns=[].slice.call(seg.querySelectorAll('.seg-btn'));
    function place(b,anim){var sr=seg.getBoundingClientRect(),br=b.getBoundingClientRect();if(!anim)thumb.style.transition='none';thumb.style.width=br.width+'px';thumb.style.height=br.height+'px';thumb.style.transform='translate('+(br.left-sr.left)+'px,'+(br.top-sr.top)+'px)';if(!anim){void thumb.offsetWidth;thumb.style.transition='';}}
    function apply(v){frame.querySelectorAll('.hero-img').forEach(function(i){i.classList.toggle('on',i.dataset.state===v);});var b=seg.querySelector('.seg-btn[data-value="'+v+'"]');if(cap)cap.textContent=b?(b.getAttribute('data-caption')||''):'';}
    function select(b,anim){btns.forEach(function(x){x.classList.toggle('on',x===b);});place(b,anim);apply(b.dataset.value);}
    btns.forEach(function(b){b.addEventListener('click',function(){select(b,true);});});
    function cur(){return seg.querySelector('.seg-btn.on')||btns[0];}
    requestAnimationFrame(function(){select(cur(),false);});
    window.addEventListener('resize',function(){place(cur(),false);});
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){place(cur(),false);});
  }
  function boot(){document.querySelectorAll('.vt-hero .hero-pills').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();
})();
